<template>
  <DefaultLayout>
    <v-row class="mx-5 mt-5">
      <v-col cols="12">
        <h2 class="text-red-600 text-3xl font-inter font-bold">
          Daftar Kontraktor
        </h2>
        <p class="text-gray-500">
          Sini-Saja membantu mengelola & memantau perkembangan kegiatan
          kontraktor
        </p>
        <v-row class="bg-white rounded-lg p-3 shadow-md mt-5">
          <v-col cols="4">
            <v-text-field
              variant="outlined"
              density="compact"
              color="red"
              hide-details
              clearable
              v-model="formValues.keyword"
              v-on:keyup.enter="fetchData"
              prepend-inner-icon="mdi-magnify"
              placeholder="Masukkan Nama Kontraktor"
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-btn
              class="bg-red-600 w-full text-white capitalize"
              @click="fetchData()"
            >
              Cari Kontraktor
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" class="mt-4 rounded-lg shadow-md">
        <v-data-table-server
          v-model:items-per-page="dataTable.pagination.itemsPerPage"
          :items-per-page-options="[5, 10, 25, 50, 100]"
          :headers="dataTable.headers"
          :items="dataTable.items"
          :items-length="dataTable.pagination.totalItems"
          @update:options="fetchData"
        >
          <template v-slot:item="{ item, index }">
            <tr
              class="border-b border-gray-950 h-16"
              :class="{ 'bg-gray-50': index % 2 !== 0 }"
            >
              <td class="text-nowrap">{{ item.namaKontraktor }}</td>
              <td class="text-nowrap">
                <a
                  @click="
                    redirectToLink(
                      '/manajement/detail-add-kontraktor/',
                      item.id
                    )
                  "
                  class="text-red-700 font-bold text-sm font-inter cursor-pointer"
                >
                  Lihat Detail
                </a>
              </td>
            </tr>
          </template>
        </v-data-table-server>
      </v-col>
    </v-row>
  </DefaultLayout>
</template>

<script>
import router from "../../router";
// import SidebarComponent from "@/components/SideBar.vue";
import GlobalDataMixin from "../../GlobalDataMixin";
import axios from "axios";

import {
  API_BASE_URL,
  CMS_GET_DETAIL_SUPPLIER,
  CMS_GET_LIST_SUPPLIER,
} from "../../constants.js";
import DefaultLayout from "@/layouts/DefaultLayout.vue";
import {
  CreateDataTableObject,
  SetDataTableResponse,
} from "@/utilities/DataTableHelpers";

const url_list = API_BASE_URL + CMS_GET_LIST_SUPPLIER;
const url_get_kontraktor = API_BASE_URL + CMS_GET_DETAIL_SUPPLIER;

export default {
  mixins: [GlobalDataMixin],
  name: "AddKontraktorPage",
  components: { DefaultLayout },
  data() {
    return {
      dataTable: CreateDataTableObject([
        { title: "Nama Kontraktor", align: "start", sortable: false, width: "90%" },
        { title: "", align: "start", sortable: false, width: "10%" },
      ]),
      isLoading: false,
      suppliers: [],
      detailSupplier: "",
      formValues: {
        currentPage: 1,
        perPage: 5,
        totalData: 0,
        keyword: "",
      },
      filter: {
        namaKontraktor: "",
      },
    };
  },
  methods: {
    fetchData({ page, itemsPerPage } = {}) {
      if (page) {
        this.formValues.currentPage = page;
      }
      if (itemsPerPage) {
        this.formValues.perPage = itemsPerPage;
      }
      let bodyJson = {
        page: this.formValues.currentPage,
        perPage: this.formValues.perPage,
        search: this.formValues.keyword,
      };
      axios
        .post(url_list, bodyJson, {
          headers: {
            role: "isafe",
            Authorization: "Bearer " + this.userData.token,
            accept: "application/json",
          },
        })
        .then((response) => {
          let result = {};
          result.data = response.data.data;
          result.total_data = response.data.totalData;
          result.total_per_page = this.formValues.perPage;
          result.current_page = this.formValues.currentPage;

          this.dataTable = SetDataTableResponse(this.dataTable, result);

          // console.log("getSuppliers => ", response);
          this.suppliers = response.data.data;
          this.formValues.totalData = response.data.totalData;
        })
        .catch((error) => console.log("error getSuppliers : ", error));
    },
    closeModal() {
      document.getElementById("btnClose").click();
    },
    terapkan() {
      this.closeModal();
      this.fetchData();
    },
    refresh() {
      location.reload();
    },
    redirectToLink(link, id) {
      axios
        .get(url_get_kontraktor + id, {
          headers: {
            role: "isafe",
            Authorization: "Bearer " + this.userData.token,
            accept: "application/json",
          },
        })
        .then(() => router.push(link + id))
        .catch(() => alert("Kontraktor sudah pernah ditambahkan"));
    },
    changePage(num) {
      let cp = this.formValues.currentPage + num;
      if (
        !(num == -1 && this.formValues.currentPage == 1) &&
        cp * this.formValues.perPage <=
          this.formValues.totalData + (this.formValues.perPage - 1)
      ) {
        this.formValues.currentPage = this.formValues.currentPage + num;
        console.log("this.currentPage", this.formValues.currentPage);
        console.log(
          "jumlah:",
          this.formValues.currentPage * this.formValues.perPage
        );
        this.fetchData();
      }
    },
  },
};
</script>

<style scoped>
:deep(thead) {
  background-color: #fecaca;
}
</style>
